import { QueryPartStrategy } from '../../../advanced-search/filters/base/entities/query-part-strategy';
import { QueryPart } from '../../../advanced-search/filters/base/entities/query-part.class';

export const mergeQueryParts: (qp: QueryPart[]) => QueryPart[] = (queryParts: QueryPart[]): QueryPart[] => {
    const start: QueryPart[] = [];
    const strategiesToMerge: QueryPartStrategy[] = [QueryPartStrategy.MatchAll, QueryPartStrategy.MatchNone];

    const reduced: QueryPart[] = queryParts.reduce((list, currentQueryPart) => {
        if (strategiesToMerge.includes(currentQueryPart.strategy)) {
            const existingQueryPart: QueryPart | undefined = list.find(
                (queryPart: QueryPart) =>
                    queryPart.field === currentQueryPart.field && queryPart.strategy === currentQueryPart.strategy
            );

            if (existingQueryPart instanceof QueryPart) {
                const listWithoutExisting: QueryPart[] = list.filter(
                    listElement =>
                        !(
                            listElement.field === existingQueryPart.field &&
                            listElement.strategy === existingQueryPart.strategy
                        )
                );
                const mergedQueryPart: QueryPart = QueryPart.merge(existingQueryPart, currentQueryPart);
                return [...listWithoutExisting, mergedQueryPart];
            }
        }
        return [...list, currentQueryPart];
    }, start);

    return reduced;
};
